// ==================================================
//  Works Post Image Thumbnail
// ==================================================
document.addEventListener("DOMContentLoaded", function () {
  const imageThumbnail = document.querySelectorAll(".imageThumbnail-js");
  const imageThumbnailImgElm = document.querySelectorAll(".imageThumbnail-js img");
  const keyvisualImageImgElm = document.querySelector(".keyvisualImage-js img");
  for (let i = 0; i < imageThumbnail.length; i++) {
    imageThumbnail[i].addEventListener("click", function () {
      keyvisualImageImgElm.setAttribute("src", imageThumbnailImgElm[i].getAttribute("src"));
    });
  }
});
